const Menu = [
  //{ name: 'Dashboard', icon: 'dashboard', title: 'Inicio', component: 'Dashboard' },
  { name: 'autores', icon: 'face', title: 'Autores', component: 'autores' },
  { name: 'categorias', icon: 'subject', title: 'Categorías', component: 'categorias' },
  { name: 'editoriales', icon: 'account_balance', title: 'Editoriales', component: 'editoriales' },
  { name: 'libros', icon: 'book', title: 'Libros', component: 'libros' },
  { name: 'usuarios', icon: 'supervisor_account', title: 'Usuarios', component: 'usuarios' },
  { name: 'bitacora', icon: 'security', title: 'Bitácora', component: 'bitacora' },

];
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;
